<div
  class="snackbar-container"
  [ngClass]="{
    success: data.type === 'success',
    error: data.type === 'error',
    info: data.type === 'info',
    warning: data.type === 'warning',
  }"
>
  <div class="main-content">
    <span class="snackbar-message" matSnackBarLabel>
      {{ data.message | translate: data.params }}
    </span>
    <span class="snackbar-actions" matSnackBarActions>
      <button
        matButton
        class="snackbar-dismiss-button"
        matSnackBarAction
        (click)="snackBarRef.dismissWithAction()"
      >
        {{ 'components.snackbar.dismiss' | translate }}
      </button>
    </span>
  </div>
  <!-- Decorative: it mirrors the auto-dismiss timer, which assistive tech
       announces through the snackbar container itself. -->
  <div
    class="snackbar-countdown"
    [class.snackbar-countdown--running]="running()"
    [style.--snackbar-countdown-duration]="countdownDuration"
    aria-hidden="true"
  ></div>
</div>
